import React from 'react';
import { fieldLabelAttCadastral } from '@utils';

export const SectionTable = ({ title, keys, changedValues }) => {
  if (!keys.length) return null;
  return (
    <>
      <tr
        style={{
          borderBottom: '1px solid #e0e0e0',
          padding: '8px 0',
        }}
      >
        <td
          colSpan={2}
          style={{
            fontWeight: 'bold',
            paddingRight: '8px',
            color: '#fff',
            backgroundColor: 'black',
          }}
        >
          {title}
        </td>
      </tr>
      {keys.map((key) => (
        <tr
          key={key}
          style={{
            borderBottom: '1px solid #e0e0e0',
            padding: '8px 0',
          }}
        >
          <td
            style={{
              fontWeight: 'bold',
              paddingRight: '8px',
              color: '#555',
            }}
          >
            {fieldLabelAttCadastral[key]?.label || key}:
          </td>
          <td style={{ color: '#000' }}>{changedValues[key]}</td>
        </tr>
      ))}
    </>
  );
};
